import * as React from 'react'
import { CountBubbleWidget } from './CountBubbleWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const CountBubbleWidgetExamples = () => {
  return (
    <div className="CountBubbleWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <CountBubbleWidget />
      </Provider>
    </div>
  )
}
